import { useEffect, useState } from "react";

import type { DashboardRepositoryTopologyResponse } from "../dashboard-client/types.gen";

import { getRepositoryTopologyAsUser } from "../dashboard-client";
import { formatErrorMessage } from "../utils/errors";

export type TopologyNode = DashboardRepositoryTopologyResponse["nodes"][number];

export type TopologyRelationship =
  DashboardRepositoryTopologyResponse["relationships"][number];

interface TopologyState {
  nodes: TopologyNode[];
  relationships: TopologyRelationship[];
  loading: boolean;
  error: string | null;
}

const initialState: TopologyState = {
  error: null,
  loading: true,
  nodes: [],
  relationships: [],
};

export function useRepositoryTopology() {
  const [state, setState] = useState<TopologyState>(initialState);

  useEffect(() => {
    let canceled = false;
    void getRepositoryTopologyAsUser()
      .then((res) => {
        if (!canceled) {
          setState({
            error: null,
            loading: false,
            nodes: res.data.nodes,
            relationships: res.data.relationships,
          });
        }
      })
      .catch((error: unknown) => {
        if (!canceled) {
          setState({
            error: formatErrorMessage(error),
            loading: false,
            nodes: [],
            relationships: [],
          });
        }
      });
    return () => {
      canceled = true;
    };
  }, []);

  return state;
}
